import { Link } from "react-router-dom";
import { ArrowLeft, Mail } from "lucide-react";

const LOGO = "/assets/logo.png";

export default function Privacy() {
  return (
    <main className="sm-legal-page" data-testid="privacy-page">
      <header className="sm-legal-header">
        <Link to="/" className="sm-legal-header__logo" data-testid="privacy-logo-link">
          <img src={LOGO} alt="Santa Maria Legal Advisory" />
        </Link>
        <Link to="/" className="sm-legal-back" data-testid="privacy-back">
          <ArrowLeft size={14} strokeWidth={2} /> Back to site
        </Link>
      </header>

      <article className="sm-legal-body">
        <div className="sm-eyebrow sm-eyebrow--gold">PRIVACY POLICY</div>
        <h1 className="sm-legal-title">How we handle your information</h1>
        <p className="sm-legal-meta">Last updated: 22 June 2026</p>

        <section>
          <h2>1. Who we are</h2>
          <p>
            Santa Maria Legal Advisory Ltd ("we", "us", "our") is a company registered in England
            and Wales (Company No. 17187611), with registered office at 3rd Floor, 45 Albemarle
            Street, Mayfair, London W1S 4JL. We act as the data controller for personal data you
            submit through this website.
          </p>
        </section>

        <section>
          <h2>2. What data we collect</h2>
          <p>
            Through the contact form on this website we collect only the information you choose
            to provide: your first and last name, email address, phone number, and the content of
            your enquiry. We do not knowingly collect special category or sensitive personal data,
            and we do not hold client money or operate client accounts.
          </p>
        </section>

        <section>
          <h2>3. How we use your data</h2>
          <p>Your data is used solely to:</p>
          <ul>
            <li>respond to your enquiry and discuss potential engagement;</li>
            <li>send you an automated acknowledgement of receipt;</li>
            <li>maintain a record of communications for legal and regulatory purposes.</li>
          </ul>
          <p>
            We do not sell, rent or share your personal data with third parties for marketing.
          </p>
        </section>

        <section>
          <h2>4. Legal basis (UK GDPR)</h2>
          <p>
            We process your data on the basis of your <em>consent</em> (Article 6(1)(a)) when you
            submit the contact form, and on the basis of our <em>legitimate interest</em> (Article
            6(1)(f)) in operating, securing and improving our advisory services.
          </p>
        </section>

        <section>
          <h2>5. Cookies</h2>
          <p>
            This site uses only strictly necessary technical cookies required for the website to
            function. We do not use advertising, profiling or third-party analytics cookies. If
            this ever changes we will update this policy and present a cookie consent banner.
          </p>
        </section>

        <section>
          <h2>6. Data storage &amp; processors</h2>
          <p>
            Enquiries are stored on secure infrastructure within the UK/EEA and are transmitted
            via Resend (our email delivery provider). Resend acts as a processor on our behalf
            under a data processing agreement.
          </p>
        </section>

        <section>
          <h2>7. Retention</h2>
          <p>
            We keep enquiry records for as long as needed to respond to you and, where an
            engagement follows, in line with applicable legal and professional obligations.
            Where no engagement results, we delete records after 24 months unless otherwise
            required.
          </p>
        </section>

        <section>
          <h2>8. Your rights</h2>
          <p>
            Under UK GDPR you have the right to access, rectify, erase, restrict or object to the
            processing of your personal data, and the right to data portability. To exercise any
            of these rights, contact us at{" "}
            <a href="mailto:info@smlegal.co.uk">info@smlegal.co.uk</a>. You may also lodge a
            complaint with the Information Commissioner's Office (ICO) at{" "}
            <a href="https://ico.org.uk" target="_blank" rel="noopener noreferrer">
              ico.org.uk
            </a>
            .
          </p>
        </section>

        <section>
          <h2>9. Regulatory notice</h2>
          <p>
            Santa Maria Legal Advisory Ltd is registered in England and Wales (Company No. 17187611). We provide specialist legal advisory and consultancy services. We are an independent advisory firm and are not authorised or regulated by the Solicitors Regulation Authority. We do not carry out reserved legal activities and do not hold client money. The information on this website does not constitute legal advice or establish a solicitor-client relationship.
          </p>
        </section>

        <section>
          <h2>10. Contact</h2>
          <p>
            For any privacy-related question, please email{" "}
            <a href="mailto:info@smlegal.co.uk">
              <Mail size={13} strokeWidth={1.8} style={{ display: "inline", verticalAlign: "-2px" }} /> info@smlegal.co.uk
            </a>
            .
          </p>
        </section>

        <div className="sm-legal-footer-link">
          <Link to="/" data-testid="privacy-bottom-back" className="sm-btn sm-btn--gold">
            Back to Home <ArrowLeft size={14} strokeWidth={2} style={{ transform: "rotate(180deg)" }} />
          </Link>
        </div>
      </article>
    </main>
  );
}
